// ============================================================
//  lib/format.ts — formateo de fechas determinista (sin saltos de hidratación).
//  SIEMPRE con timeZone fija para que servidor y cliente coincidan.
// ============================================================
const TZ = "Europe/Madrid";

const dateFmt = new Intl.DateTimeFormat("es-ES", {
  day: "numeric",
  month: "short",
  year: "numeric",
  timeZone: TZ,
});

const timeFmt = new Intl.DateTimeFormat("es-ES", {
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: TZ,
});

/** Fecha corta y estable: "9 jun 2026". */
export function formatDate(value: Date | string): string {
  return dateFmt.format(new Date(value));
}

/** Fecha con hora: "9 jun, 18:30". */
export function formatDateTime(value: Date | string): string {
  return timeFmt.format(new Date(value));
}
